import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Phone, MapPin, Leaf } from 'lucide-react';
import { Separator } from './ui/separator';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer 
      className="bg-[#1C1C1E] text-white relative overflow-hidden"
      role="contentinfo"
    >
      {/* Decorative element */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-sage via-gold to-sage"></div>
      
      <div className="container-main py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Logo & Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-sage rounded-xl flex items-center justify-center">
                <Leaf className="w-5 h-5 text-white" aria-hidden="true" />
              </div>
              <div>
                <h3 className="font-heading text-xl font-bold text-white">
                  {t('footer.clinic')}
                </h3>
                <span className="font-body text-sm text-white/60">
                  {t('footer.clinicKorean')}
                </span>
              </div>
            </div>
            <p className="font-body text-white/70 text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-white mb-4">
              {t('nav.contact')}
            </h4>
            <div className="space-y-3">
              <a 
                href="tel:+17145915360"
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors duration-200"
                data-testid="footer-phone"
              >
                <Phone className="w-4 h-4" aria-hidden="true" />
                <span className="font-body">(714) 591-5360</span>
              </a>
              <div className="flex items-start gap-3 text-white/70">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" aria-hidden="true" />
                <address className="font-body not-italic">
                  9860 Garden Grove Blvd<br />
                  Garden Grove, CA 92844
                </address>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-white mb-4">
              {t('nav.services')}
            </h4>
            <ul className="space-y-2 font-body text-white/70 text-sm">
              <li>{t('services.chronicPain')}</li>
              <li>{t('services.sinus')}</li>
              <li>{t('services.sleep')}</li>
              <li>{t('services.perimenopause')}</li>
              <li>{t('services.energy')}</li>
            </ul>
          </div>
        </div>

        <Separator className="bg-white/10 mb-8" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-white/50 text-sm">
            {t('footer.copyright')}
          </p>
          
          {/* SEO Keywords (visible for SEO, styled subtly) */}
          <p 
            className="font-body text-white/30 text-xs"
            aria-hidden="true"
          >
            {t('footer.seo')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
